import TagFormContainer from './TagFormContainer';

export default TagFormContainer;
